import type { OTStage } from "@/features/transit/api/types"

// Backend stages, in order. The label shown to the user comes from the
// `transit:stages.<code>` i18n key — never hard-code French in components.
export const OT_STAGES: OTStage[] = [
  "CREATED",
  "ANALYSE",
  "FORMULE",
  "EMPOTAGE",
  "EMBARQUEMENT",
  "REMISE",
  "TERMINER",
]

export function stageIndex(stage: OTStage): number {
  return OT_STAGES.indexOf(stage)
}

export function isStageDone(current: OTStage, candidate: OTStage): boolean {
  return stageIndex(candidate) < stageIndex(current)
}

export function isStageUnlocked(
  unlockedStages: OTStage[] | undefined,
  candidate: OTStage,
): boolean {
  return !!unlockedStages?.includes(candidate)
}

export function nextStage(current: OTStage): OTStage | null {
  const idx = stageIndex(current)
  if (idx < 0 || idx >= OT_STAGES.length - 1) return null
  return OT_STAGES[idx + 1]
}

export function prevStage(current: OTStage): OTStage | null {
  const idx = stageIndex(current)
  if (idx <= 0) return null
  return OT_STAGES[idx - 1]
}
